/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDim2DiagMaxRightIcon20Regular = forwardRef('ArrowDim2DiagMaxRightIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M11.75 2.25a.75.75 0 0 0 0 1.5h3.44l-4.22 4.22a.75.75 0 0 0 1.06 1.06l4.22-4.22v3.44a.75.75 0 0 0 1.5 0V4A1.75 1.75 0 0 0 16 2.25h-4.25Z" }),
        React.createElement("path", { d: "M9.03 12.03a.75.75 0 1 0-1.06-1.06l-4.22 4.22v-3.44a.75.75 0 0 0-1.5 0V16c0 .966.784 1.75 1.75 1.75h4.25a.75.75 0 0 0 0-1.5H4.81l4.22-4.22Z" })));
});
